import type { Filter } from '@frontend/api';

export function buildFilterUpdate<
  T extends Record<K, Filter<V>>,
  K extends string,
  V extends string = 'values',
>(
  setFilters: React.Dispatch<React.SetStateAction<T>>,
  filterKey: K,
  valueKey?: V,
) {
  return (value: string) => {
    const key = valueKey ?? ('values' as keyof T[K]); // HACK: TypeScript doesn't handle generic function parameter defaults well
    setFilters((filters) => {
      const oldValue = filters[filterKey][key];
      return {
        ...filters,
        [filterKey]: {
          ...filters[filterKey],
          [key]: oldValue.includes(value)
            ? oldValue.filter((old: unknown) => old !== value)
            : [...oldValue, value],
        },
      };
    });
  };
}

export const DEFAULT_SEE_MORE_INC = 10;

export function buildFilterSeeMore<
  T extends Record<K, Pick<Filter, 'size'>>,
  K extends string,
>(
  setFilters: React.Dispatch<React.SetStateAction<T>>,
  filterKey: K,
  { inc = DEFAULT_SEE_MORE_INC }: { inc?: number } = {},
) {
  return () => {
    setFilters((filters) => {
      const oldValue = filters[filterKey].size;
      return {
        ...filters,
        [filterKey]: {
          ...filters[filterKey],
          size: oldValue + inc,
        },
      };
    });
  };
}
